import {AxiosResponse} from 'axios';
import {gateway} from '../config/api';
import * as AuthUtils from '../utils/authUtils';

async function loginWithEmail(
  username: string,
  password: string,
): Promise<string> {
  const res: AxiosResponse = await gateway().post('/auth', {
    username,
    password,
  });

  const token = res.data as string;

  if (res.status === 200) {
    AuthUtils.setHeaders(token);
    return token;
  }
  if (res.status === 401) {
    return Promise.reject('Incorrect email or password');
  }
  return Promise.reject('Sorry, something went wrong');
}

async function loginAs(email: string, password: string, behalfOf: string) {
  const res: AxiosResponse = await gateway().post('/auth/loginAs', {
    email,
    password,
    on_behalf_of: behalfOf,
  });

  const token = res.data as string;

  if (res.status === 200) {
    AuthUtils.setHeaders(token);
    return token;
  }
  if (res.status === 401) {
    return Promise.reject('Incorrect email or password');
  }
  return Promise.reject('Sorry, something went wrong');
}

async function loginAsGuest() {
  const res: AxiosResponse = await gateway().post('/user/login-as-guest');

  const token = res.data as string;

  if (res.status === 200) {
    AuthUtils.setHeaders(token);
    return token;
  }
  return Promise.reject('Sorry, something went wrong');
}

function logout() {
  AuthUtils.setHeaders();
}

export type SignupRequestType = {
  email: string;
  password: string;
  first_name: string;
  last_name: string;
  newsletter_subscribed: boolean;
};

async function signup(authData: SignupRequestType) {
  const res: AxiosResponse = await gateway().post(
    '/auth-users/register',
    authData,
  );
  const token = res.data as string;

  if (res.status === 200) {
    AuthUtils.setHeaders(token);
    return token;
  }
  return Promise.reject('Sorry, something went wrong');
}

async function validateEmail(emailAddress: string) {
  const res: AxiosResponse = await gateway().post(
    '/auth-users/validate_email',
    emailAddress,
    {
      headers: {
        'Content-Length': 0,
        'Content-Type': 'text/plain',
      },
    },
  );

  if (res.status === 200) {
    return [];
  }
  if (res.status === 400) {
    return ['Invalid email address'];
  }
  if (res.status === 409) {
    return ['Email address already in use'];
  }
  return Promise.reject('Sorry, something went wrong');
}

export default {
  loginWithEmail,
  loginAs,
  loginAsGuest,
  logout,
  signup,
  validateEmail,
};
